/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { ExceptionResponseDTO } from '../model/exception-response-dto';
// @ts-ignore
import { GetProfiloServizio409Response } from '../model/get-profilo-servizio409-response';
// @ts-ignore
import { GetProfiloServizio422Response } from '../model/get-profilo-servizio422-response';
// @ts-ignore
import { PeriodoRendicontazioneCreationForm } from '../model/periodo-rendicontazione-creation-form';
// @ts-ignore
import { PeriodoRendicontazioneDTO } from '../model/periodo-rendicontazione-dto';
// @ts-ignore
import { RendicontazioneEsercenteDTO } from '../model/rendicontazione-esercente-dto';
// @ts-ignore
import { RendicontazioneNotaForm } from '../model/rendicontazione-nota-form';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    GestioneRendicontazioneEsercentiServiceInterface,
    AccettaRendicontazioneBackofficeRequestParams,
    ChiudiPeriodoRendicontazioneBackofficeRequestParams,
    DownloadFileRendicontazioneBackofficeRequestParams,
    DownloadNotaDebitoRendicontazioneBackofficeRequestParams,
    GeneraPeriodoRendicontazioneManualeRequestParams,
    GetRendicontazioneBackofficeRequestParams,
    ListPeriodiRendicontazioneBackofficeRequestParams,
    ListRendicontazioniPeriodoBackofficeRequestParams,
    PagataRendicontazioneBackofficeRequestParams,
    RifiutaRendicontazioneBackofficeRequestParams
} from './gestione-rendicontazione-esercenti.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class GestioneRendicontazioneEsercentiService extends BaseService implements GestioneRendicontazioneEsercentiServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Accetta una rendicontazione (backoffice), con controfirmata opzionale.
     * Multipart: part \&#39;controfirmata\&#39; (file opzionale) + part \&#39;nota\&#39; (JSON opzionale). {SOTTOMESSA, RIFIUTATA} → ACCETTATA.
     * @endpoint post /api/v1/gestione/tipi-pratica/{id_tipo_pratica}/rendicontazioni/{id_rendicontazione}/accetta
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public accettaRendicontazioneBackoffice(requestParameters: AccettaRendicontazioneBackofficeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<RendicontazioneEsercenteDTO>;
    public accettaRendicontazioneBackoffice(requestParameters: AccettaRendicontazioneBackofficeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<RendicontazioneEsercenteDTO>>;
    public accettaRendicontazioneBackoffice(requestParameters: AccettaRendicontazioneBackofficeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<RendicontazioneEsercenteDTO>>;
    public accettaRendicontazioneBackoffice(requestParameters: AccettaRendicontazioneBackofficeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling accettaRendicontazioneBackoffice.');
        }
        const idRendicontazione = requestParameters?.idRendicontazione;
        if (idRendicontazione === null || idRendicontazione === undefined) {
            throw new Error('Required parameter idRendicontazione was null or undefined when calling accettaRendicontazioneBackoffice.');
        }
        const nota = requestParameters?.nota;
        const controfirmata = requestParameters?.controfirmata;

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'nota',
            <any>nota,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        localVarUseForm = canConsumeForm;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (controfirmata !== undefined) {
            localVarFormParams = localVarFormParams.append('controfirmata', <any>controfirmata) as any || localVarFormParams;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/rendicontazioni/${this.configuration.encodeParam({name: "idRendicontazione", value: idRendicontazione, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/accetta`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<RendicontazioneEsercenteDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Chiusura amministrativa di un periodo (backoffice). ABILITATO → DISABILITATO.
     * @endpoint patch /api/v1/gestione/tipi-pratica/{id_tipo_pratica}/rendicontazioni/periodi/{id_periodo}/chiudi
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public chiudiPeriodoRendicontazioneBackoffice(requestParameters: ChiudiPeriodoRendicontazioneBackofficeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PeriodoRendicontazioneDTO>;
    public chiudiPeriodoRendicontazioneBackoffice(requestParameters: ChiudiPeriodoRendicontazioneBackofficeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PeriodoRendicontazioneDTO>>;
    public chiudiPeriodoRendicontazioneBackoffice(requestParameters: ChiudiPeriodoRendicontazioneBackofficeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PeriodoRendicontazioneDTO>>;
    public chiudiPeriodoRendicontazioneBackoffice(requestParameters: ChiudiPeriodoRendicontazioneBackofficeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling chiudiPeriodoRendicontazioneBackoffice.');
        }
        const idPeriodo = requestParameters?.idPeriodo;
        if (idPeriodo === null || idPeriodo === undefined) {
            throw new Error('Required parameter idPeriodo was null or undefined when calling chiudiPeriodoRendicontazioneBackoffice.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/rendicontazioni/periodi/${this.configuration.encodeParam({name: "idPeriodo", value: idPeriodo, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/chiudi`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PeriodoRendicontazioneDTO>('patch', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Scarica il file nota firmata / controfirmata caricato (backoffice).
     * ?controfirmata&#x3D;true per la controfirmata. File non valorizzato → 404.
     * @endpoint get /api/v1/gestione/tipi-pratica/{id_tipo_pratica}/rendicontazioni/{id_rendicontazione}/file
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public downloadFileRendicontazioneBackoffice(requestParameters: DownloadFileRendicontazioneBackofficeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Blob>;
    public downloadFileRendicontazioneBackoffice(requestParameters: DownloadFileRendicontazioneBackofficeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Blob>>;
    public downloadFileRendicontazioneBackoffice(requestParameters: DownloadFileRendicontazioneBackofficeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Blob>>;
    public downloadFileRendicontazioneBackoffice(requestParameters: DownloadFileRendicontazioneBackofficeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/octet-stream' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling downloadFileRendicontazioneBackoffice.');
        }
        const idRendicontazione = requestParameters?.idRendicontazione;
        if (idRendicontazione === null || idRendicontazione === undefined) {
            throw new Error('Required parameter idRendicontazione was null or undefined when calling downloadFileRendicontazioneBackoffice.');
        }
        const controfirmata = requestParameters?.controfirmata;

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'controfirmata',
            <any>controfirmata,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/octet-stream',
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/rendicontazioni/${this.configuration.encodeParam({name: "idRendicontazione", value: idRendicontazione, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/file`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: "blob",
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Scarica il PDF nota di debito di una rendicontazione (backoffice).
     * @endpoint get /api/v1/gestione/tipi-pratica/{id_tipo_pratica}/rendicontazioni/{id_rendicontazione}/nota-debito
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public downloadNotaDebitoRendicontazioneBackoffice(requestParameters: DownloadNotaDebitoRendicontazioneBackofficeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Blob>;
    public downloadNotaDebitoRendicontazioneBackoffice(requestParameters: DownloadNotaDebitoRendicontazioneBackofficeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Blob>>;
    public downloadNotaDebitoRendicontazioneBackoffice(requestParameters: DownloadNotaDebitoRendicontazioneBackofficeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Blob>>;
    public downloadNotaDebitoRendicontazioneBackoffice(requestParameters: DownloadNotaDebitoRendicontazioneBackofficeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling downloadNotaDebitoRendicontazioneBackoffice.');
        }
        const idRendicontazione = requestParameters?.idRendicontazione;
        if (idRendicontazione === null || idRendicontazione === undefined) {
            throw new Error('Required parameter idRendicontazione was null or undefined when calling downloadNotaDebitoRendicontazioneBackoffice.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/pdf',
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/rendicontazioni/${this.configuration.encodeParam({name: "idRendicontazione", value: idRendicontazione, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/nota-debito`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: "blob",
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Genera manualmente un periodo di rendicontazione su un intervallo esplicito (SUPERADMIN).
     * Innescabile SOLO da SUPERADMIN (matcher dedicato in SecurityConfigApi, dichiarato PRIMA del catch-all SUPERADMIN|OP_COMUNE|OP_PRATICA_ESERCENTE della famiglia rendicontazioni). Il cron mensile non rigenera/sovrascrive un periodo già coperto: se l\&#39;intervallo si sovrappone a un periodo su cui esiste già un invio esercente (status diverso da DA_SOTTOMETTERE), l\&#39;operazione è rifiutata (422): per rigenerare, rifiutare prima la rendicontazione. Il compute gira su tutti gli esercenti ABILITATI del bando (il periodo è del bando, non di un singolo negozio).
     * @endpoint post /api/v1/gestione/tipi-pratica/{id_tipo_pratica}/rendicontazioni/periodi/genera
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public generaPeriodoRendicontazioneManuale(requestParameters: GeneraPeriodoRendicontazioneManualeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PeriodoRendicontazioneDTO>;
    public generaPeriodoRendicontazioneManuale(requestParameters: GeneraPeriodoRendicontazioneManualeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PeriodoRendicontazioneDTO>>;
    public generaPeriodoRendicontazioneManuale(requestParameters: GeneraPeriodoRendicontazioneManualeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PeriodoRendicontazioneDTO>>;
    public generaPeriodoRendicontazioneManuale(requestParameters: GeneraPeriodoRendicontazioneManualeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling generaPeriodoRendicontazioneManuale.');
        }
        const periodoRendicontazioneCreationForm = requestParameters?.periodoRendicontazioneCreationForm;
        if (periodoRendicontazioneCreationForm === null || periodoRendicontazioneCreationForm === undefined) {
            throw new Error('Required parameter periodoRendicontazioneCreationForm was null or undefined when calling generaPeriodoRendicontazioneManuale.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/rendicontazioni/periodi/genera`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PeriodoRendicontazioneDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: periodoRendicontazioneCreationForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Dettaglio di una rendicontazione esercente (backoffice).
     * @endpoint get /api/v1/gestione/tipi-pratica/{id_tipo_pratica}/rendicontazioni/{id_rendicontazione}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getRendicontazioneBackoffice(requestParameters: GetRendicontazioneBackofficeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<RendicontazioneEsercenteDTO>;
    public getRendicontazioneBackoffice(requestParameters: GetRendicontazioneBackofficeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<RendicontazioneEsercenteDTO>>;
    public getRendicontazioneBackoffice(requestParameters: GetRendicontazioneBackofficeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<RendicontazioneEsercenteDTO>>;
    public getRendicontazioneBackoffice(requestParameters: GetRendicontazioneBackofficeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling getRendicontazioneBackoffice.');
        }
        const idRendicontazione = requestParameters?.idRendicontazione;
        if (idRendicontazione === null || idRendicontazione === undefined) {
            throw new Error('Required parameter idRendicontazione was null or undefined when calling getRendicontazioneBackoffice.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/rendicontazioni/${this.configuration.encodeParam({name: "idRendicontazione", value: idRendicontazione, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<RendicontazioneEsercenteDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Periodi di rendicontazione di un bando (backoffice).
     * @endpoint get /api/v1/gestione/tipi-pratica/{id_tipo_pratica}/rendicontazioni/periodi
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listPeriodiRendicontazioneBackoffice(requestParameters: ListPeriodiRendicontazioneBackofficeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<PeriodoRendicontazioneDTO>>;
    public listPeriodiRendicontazioneBackoffice(requestParameters: ListPeriodiRendicontazioneBackofficeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<PeriodoRendicontazioneDTO>>>;
    public listPeriodiRendicontazioneBackoffice(requestParameters: ListPeriodiRendicontazioneBackofficeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<PeriodoRendicontazioneDTO>>>;
    public listPeriodiRendicontazioneBackoffice(requestParameters: ListPeriodiRendicontazioneBackofficeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling listPeriodiRendicontazioneBackoffice.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/rendicontazioni/periodi`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<PeriodoRendicontazioneDTO>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Rendicontazioni di un periodo (una per esercente abilitato), ricalcolate.
     * @endpoint get /api/v1/gestione/tipi-pratica/{id_tipo_pratica}/rendicontazioni/periodi/{id_periodo}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listRendicontazioniPeriodoBackoffice(requestParameters: ListRendicontazioniPeriodoBackofficeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<RendicontazioneEsercenteDTO>>;
    public listRendicontazioniPeriodoBackoffice(requestParameters: ListRendicontazioniPeriodoBackofficeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<RendicontazioneEsercenteDTO>>>;
    public listRendicontazioniPeriodoBackoffice(requestParameters: ListRendicontazioniPeriodoBackofficeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<RendicontazioneEsercenteDTO>>>;
    public listRendicontazioniPeriodoBackoffice(requestParameters: ListRendicontazioniPeriodoBackofficeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling listRendicontazioniPeriodoBackoffice.');
        }
        const idPeriodo = requestParameters?.idPeriodo;
        if (idPeriodo === null || idPeriodo === undefined) {
            throw new Error('Required parameter idPeriodo was null or undefined when calling listRendicontazioniPeriodoBackoffice.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/rendicontazioni/periodi/${this.configuration.encodeParam({name: "idPeriodo", value: idPeriodo, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<RendicontazioneEsercenteDTO>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Segna pagata una rendicontazione dopo il bonifico (backoffice). ACCETTATA → PAGATA.
     * @endpoint post /api/v1/gestione/tipi-pratica/{id_tipo_pratica}/rendicontazioni/{id_rendicontazione}/pagata
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public pagataRendicontazioneBackoffice(requestParameters: PagataRendicontazioneBackofficeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<RendicontazioneEsercenteDTO>;
    public pagataRendicontazioneBackoffice(requestParameters: PagataRendicontazioneBackofficeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<RendicontazioneEsercenteDTO>>;
    public pagataRendicontazioneBackoffice(requestParameters: PagataRendicontazioneBackofficeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<RendicontazioneEsercenteDTO>>;
    public pagataRendicontazioneBackoffice(requestParameters: PagataRendicontazioneBackofficeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling pagataRendicontazioneBackoffice.');
        }
        const idRendicontazione = requestParameters?.idRendicontazione;
        if (idRendicontazione === null || idRendicontazione === undefined) {
            throw new Error('Required parameter idRendicontazione was null or undefined when calling pagataRendicontazioneBackoffice.');
        }
        const rendicontazioneNotaForm = requestParameters?.rendicontazioneNotaForm;

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/rendicontazioni/${this.configuration.encodeParam({name: "idRendicontazione", value: idRendicontazione, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/pagata`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<RendicontazioneEsercenteDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: rendicontazioneNotaForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Rifiuta una rendicontazione (backoffice). SOTTOMESSA → RIFIUTATA.
     * @endpoint post /api/v1/gestione/tipi-pratica/{id_tipo_pratica}/rendicontazioni/{id_rendicontazione}/rifiuta
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public rifiutaRendicontazioneBackoffice(requestParameters: RifiutaRendicontazioneBackofficeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<RendicontazioneEsercenteDTO>;
    public rifiutaRendicontazioneBackoffice(requestParameters: RifiutaRendicontazioneBackofficeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<RendicontazioneEsercenteDTO>>;
    public rifiutaRendicontazioneBackoffice(requestParameters: RifiutaRendicontazioneBackofficeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<RendicontazioneEsercenteDTO>>;
    public rifiutaRendicontazioneBackoffice(requestParameters: RifiutaRendicontazioneBackofficeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling rifiutaRendicontazioneBackoffice.');
        }
        const idRendicontazione = requestParameters?.idRendicontazione;
        if (idRendicontazione === null || idRendicontazione === undefined) {
            throw new Error('Required parameter idRendicontazione was null or undefined when calling rifiutaRendicontazioneBackoffice.');
        }
        const rendicontazioneNotaForm = requestParameters?.rendicontazioneNotaForm;

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/rendicontazioni/${this.configuration.encodeParam({name: "idRendicontazione", value: idRendicontazione, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/rifiuta`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<RendicontazioneEsercenteDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: rendicontazioneNotaForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
